import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: 'hash', //  history
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: (resolve) =>
        require([`components/views/Bimviewer.vue`], resolve),
      name: '',
      hidden: true,
    },
    {
      path: '/dev',
      component: (resolve) =>
        require([`components/views/BimviewerDev.vue`], resolve),
      name: '',
      hidden: true,
    },
    {
      path: '/cache',
      component: (resolve) =>
        require([`components/views/CreateCache.vue`], resolve),
      name: '模型预处理',
      hidden: true,
    },
    {
      path: '*',
      hidden: true,
      redirect: {
        path: '/',
      },
    },
  ],
});
